import { render } from "./servicingComponent.vue?vue&type=template&id=3ae4ba3a"
import script from "./servicingComponent.vue?vue&type=script&lang=js"
export * from "./servicingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__